import { useState, useEffect } from "react";

const SAVED = "vlmag_saved";
const VIEWED = "vlmag_viewed";

function read(key) {
  try { return JSON.parse(localStorage.getItem(key)) || []; } catch { return []; }
}
function write(key, val) {
  try { localStorage.setItem(key, JSON.stringify(val)); } catch { /* noop */ }
  window.dispatchEvent(new Event("vlmag-library"));
}

function mediaUrl(src) {
  if (!src) return "";
  return src.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${src}` : src;
}

// Warm the cache (via the service worker) so a saved story reads offline later.
export function prefetchOffline(story) {
  try {
    const base = process.env.REACT_APP_BACKEND_URL;
    fetch(`${base}/api/stories/${story.id}`).catch(() => {});
    if (story.image) fetch(mediaUrl(story.image)).catch(() => {});
  } catch { /* noop */ }
}

function toMeta(s) {
  return {
    id: s.id, title: s.title, network: s.network, category: s.category,
    image: s.image, excerpt: s.excerpt, series: s.series || "", part: s.part || 0,
    saved_at: new Date().toISOString(),
  };
}

export function getSaved() { return read(SAVED); }
export function isSaved(id) { return read(SAVED).some((s) => s.id === id); }

export function toggleSave(story) {
  const list = read(SAVED);
  const idx = list.findIndex((s) => s.id === story.id);
  if (idx >= 0) { list.splice(idx, 1); write(SAVED, list); return false; }
  list.unshift(toMeta(story));
  write(SAVED, list);
  prefetchOffline(story);
  return true;
}

export function removeSaved(id) {
  write(SAVED, read(SAVED).filter((s) => s.id !== id));
}

export function markViewed(id) {
  const l = read(VIEWED);
  if (!l.includes(id)) write(VIEWED, [id, ...l].slice(0, 200));
}

export function isOfflineAvailable(id) {
  return read(VIEWED).includes(id) || read(SAVED).some((s) => s.id === id);
}

// Re-render hook: bumps whenever the saved/viewed library changes (this tab or another).
export function useLibraryVersion() {
  const [v, setV] = useState(0);
  useEffect(() => {
    const h = () => setV((x) => x + 1);
    window.addEventListener("vlmag-library", h);
    window.addEventListener("storage", h);
    return () => {
      window.removeEventListener("vlmag-library", h);
      window.removeEventListener("storage", h);
    };
  }, []);
  return v;
}
